import { useField } from 'react-final-form';

import { HpaSettingsFormModel } from '../RightsizingSettings/_types';

export const useIsHpaSettingsMissingOnWorkloadForm = () => {
  const hpaSettingsField = useField<HpaSettingsFormModel | undefined>(
    'horizontalRightsizing.hpaSettings',
    {
      subscription: { value: true },
    }
  );

  return { isHpaSettingsMissingOnWorkloadForm: !hpaSettingsField.input.value };
};
